import React, { Component } from 'react';
import classNames from 'classnames';
import './TimeSlot.scss';
import { TIME_SLOTS, WALKTHROUGH_TIME_SLOTS, WORK_DAYS, ALBASTAR_TIME_SLOTS, WALKTHROUGH_ALBASTAR_TIME_SLOTS, PANATCH_WORK_DAYS, PANATCH_TIME_SLOTS,WALKTHROUGH_PANATCH_TIME_SLOTS   } from '../../common/constants';
import FontAwesomeIcon from '../Icon';

// import variables from '../../styles/includes/variables.scss';
class TimeSlot extends Component {
  state = {
    tab: 'Monday',
    selection: this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? this.selectedSlots(this.props.fromScheduling) : [] : [],
    filterTab:null,
    filterDay:[],
  };


  selectedSlots(data){
    let slots = []
    data.forEach(item => item.slots.forEach(value => {
      slots.push(item.day+' '+value)
    }))
    return slots

  }
  handleSelection(slot) {
    const { selection } = this.state;
    const { handleSelectionFormData } = this.props;
    let selections = []
    if(selection.includes(slot)){
        selections = selection.filter( s => s!== slot )
    }else{
        selections = [...selection, slot];
    }
     
    this.setState({ selection: selections })
 
    handleSelectionFormData(selections.join(","));
  }

  componentDidMount(){
    let theme = localStorage.getItem('theme');
    if(this.props.fromScheduling && this.props.fromScheduling.length > 0){
      this.props.handleSelectionFormData(this.state.selection.join(","));
    }
       // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 08/09/2022
      // Jira ticket: JUN-3104
      // Comment: Preferred Appointment Times will be shown as per homeowner availability.
if(this.props.from === 'srscheduling' && theme!== 'Rize' && theme!== 'Formwerks'){
  let workDays = theme === "Panatch" ? PANATCH_WORK_DAYS : WORK_DAYS
  const { filterDay }=this.state
  this.setState({filterTab:this.props.fromScheduling[0].day})
  workDays.map((dayItem,index)=>{
    this.props.fromScheduling.map((preferedDayItem)=>{
      if(dayItem === preferedDayItem.day)
      {
        let dayData= filterDay.filter((tn) => tn === preferedDayItem.day);
        if(dayData.length>0)
        {}else{
          filterDay.push(preferedDayItem.day)
        }
      }
       })
  })
 }
  }

  render() {
    const { tab, selection,filterTab } = this.state;
    let theme = localStorage.getItem('theme');
    let slots = theme === "Albaster" ? WALKTHROUGH_ALBASTAR_TIME_SLOTS : theme === "Panatch"?WALKTHROUGH_PANATCH_TIME_SLOTS : WALKTHROUGH_TIME_SLOTS  //  let days = this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? new Set( this.props.fromScheduling.map(item => item.day)) : WORK_DAYS : WORK_DAYS
    let days = theme === "Panatch" ?PANATCH_WORK_DAYS:WORK_DAYS  //  let disableForSchedule = this.props.fromScheduling ? this.props.fromScheduling.length > 0 ? true : false : false
    let disableForSchedule = false
    return (
      <div className="timeSlot">
        <div  className="timeSlot__require">
        <div className="timeSlot__label">Homeowner Availability</div>
        <div className="timeSlot__required" />
      </div>
      {
        this.props.serviceRequestForm?(<div>Please indicate what days and times might work for you.</div>):(null)
      }
      <br/>
        <div className="timeSlot__control">

{
  this.props.from === 'srscheduling'?
  (
  theme!== 'Rize' && theme!== 'Formwerks'?
  (<>
    
    <div className="timeSlot__tabs">
            {this.state.filterDay.map(day => (
              <button
                type="button"
                key={day}
                onClick={() => this.setState({ filterTab: day })}
                className={
                  classNames(
                    'timeSlot__tab',
                    {
                      'timeSlot__tab--active': day === filterTab,
                    }
                  )
                }
              >
                {day}
              </button>
            ))}
          </div>
          <div className="timeSlot__days">
            {
            this.state.selection.map((selected)=>(
             selected.includes(filterTab)?(
              <button
              type="button"
              //key={tab + ' ' + slot}
              //onClick={() => disableForSchedule ?  {} : this.handleSelection(tab + ' ' + slot)}
              className={
                classNames(
                  'timeSlot__slot',
                  {
                    'timeSlot__slot--active': selection.indexOf(selected) > -1,
                  }
                )     
              }
            >
              <div className="timeSlot__bullet">
                <FontAwesomeIcon
                  glyph="check"
                  weight="regular"
                />
              </div>
              {selected.replace(filterTab,'')}
            </button>
             ):(null)
            ))
          }
          </div>
  </>):(null)
  )
  :
  (
    <>

    <div className="timeSlot__tabs">
            {days.map(day => (
              <button
                type="button"
                key={day}
                onClick={() => this.setState({ tab: day })}
                className={
                  classNames(
                    'timeSlot__tab',
                    {
                      'timeSlot__tab--active': day === tab,
                    }
                  )
                }
              >
                {day}
              </button>
            ))}
          </div>
          <div className="timeSlot__days">
            {slots.map(slot => (
              <button
                type="button"
                key={tab + ' ' + slot}
                onClick={() => disableForSchedule ?  {} : this.handleSelection(tab + ' ' + slot)}
                className={
                  classNames(
                    'timeSlot__slot',
                    {
                      'timeSlot__slot--active': selection.indexOf(tab + ' ' + slot) > -1,
                    }
                  )
                }
              >
                <div className="timeSlot__bullet">
                  <FontAwesomeIcon
                    glyph="check"
                    weight="regular"
                  />
                </div>
                {slot}
              </button>
            ))}
          </div>
          
    </>
  )
}
          
        </div>
      </div>
    );
  }
}

export default TimeSlot;